import React, { useState } from 'react';
import cn from 'classnames';
import PropTypes from 'prop-types';

import HeaderBottom from './HeaderBottom';
import HeaderContext from './HeaderContext';
import HeaderLogo from './HeaderLogo';
import HeaderMegaMenu from './HeaderMegaMenu';
import HeaderNav from './HeaderNav';
import HeaderSearch from './HeaderSearch';
import HeaderTop from './HeaderTop';
import HeaderFlyout from './HeaderFlyout';
import Overlay from './Overlay';

const Header = ({ children, defaultOverlay = true }) => {
  const [activeFlyout, setActiveFlyout] = useState(null);
  const [activeMegaMenu, setActiveMegaMenu] = useState(null);
  const [isSearchActive, setSearchActive] = useState(false);
  const [isSuggestionsActive, setSuggestionsActive] = useState(false);

  const toggleMegaMenu = (id) => {
    setActiveMegaMenu((prevState) => (prevState === id ? null : id));
  };

  const closeMegaMenu = (id) => {
    setActiveMegaMenu((prevState) =>
      !id || id === prevState ? null : prevState
    );
  };

  const toggleFlyout = (id) => {
    setActiveFlyout((prevState) => (prevState === id ? null : id));
  };

  const context = {
    activeMegaMenu,
    toggleMegaMenu,
    closeMegaMenu,

    setSearchActive,
    isSearchActive,
    setSuggestionsActive,
    isSuggestionsActive,

    activeFlyout,
    setActiveFlyout,
    toggleFlyout,
  };

  const headerClassName = cn('c-header', {
    'is-search-open': isSearchActive,
  });

  return (
    <HeaderContext.Provider value={context}>
      {defaultOverlay && <Overlay />}
      <header className={headerClassName}>{children}</header>
    </HeaderContext.Provider>
  );
};

Header.Bottom = HeaderBottom;
Header.Logo = HeaderLogo;
Header.MegaMenu = HeaderMegaMenu;
Header.Nav = HeaderNav;
Header.Search = HeaderSearch;
Header.Top = HeaderTop;
Header.Flyout = HeaderFlyout;
Header.Overlay = Overlay;

export default Header;

Header.propTypes = {
  children: PropTypes.node.isRequired,
  defaultOverlay: PropTypes.bool,
};
